import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/shadcn/ui/select'
import {
  type TransactionType,
  InvestorRelevantTransactionTypesArray as transactionTypes,
} from '../../_transaction_types/transaction.types'

type Props = {
  value: TransactionType | 'all'
  onValueChange: (value: TransactionType) => void
}

function TransactionTypeFilter({ value, onValueChange }: Props) {
  return (
    <Select
      value={value}
      onValueChange={(transactionType) => {
        if (transactionType) {
          onValueChange(transactionType as TransactionType)
        }
      }}>
      <SelectTrigger className="w-full md:w-fit h-12.5! border border-border text-base font-semibold capitalize">
        <SelectValue placeholder="Select transaction type" />
      </SelectTrigger>
      <SelectContent className="bg-background">
        <SelectGroup>
          <SelectItem className="text-primary" value="all">
            Všetky transakcie
          </SelectItem>
          {transactionTypes.map((type) => {
            return (
              <SelectItem
                className="text-primary capitalize"
                key={type.value}
                value={type.value}>
                {type.text}
              </SelectItem>
            )
          })}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export { TransactionTypeFilter }
